import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CanalVendaLogoBadgeModule } from '../logo-badge';

import { CanalVendaSelectComponent } from './canal-venda-select.component';

@NgModule({
    imports: [
        SharedModule,
        CanalVendaLogoBadgeModule
    ],
    declarations: [
      CanalVendaSelectComponent
    ],
    exports: [
      CanalVendaSelectComponent
    ]
})
export class CanalVendaSelectModule { }
